const colors = {
  'primary-blue': {
    600: '#296BB4',
    500: '#0067DB',
    400: '#0079FF',
  },
  'primary-green': {
    500: '#3D8B40',
  },
  'primary-orange': {
    500: 'rgb(255, 119, 1)',
  },
  'primary-red': {
    500: '#D12E25',
  },
  grey: {
    900: '#000000', // black
    800: '#28292B', // primary color
    700: '#333333', // primary text
    600: '#444444', // hover
    400: '#748598', // secondary text
    300: '#BDC3D0', // disabled
    250: '#E3E4E9', // background hover
    200: '#F3F4F9', // background
  },
  gradient: {
    'primary-blue-green': 'linear-gradient(45deg, #074EE8 0%, #00B2FF 35%, #3D8B40 100%)',
  },
};

export default colors;
